<div class="row">
  <div class="col-md-6">
    <app-field-number
      [value]="value || 0"
      (valueChange)="this.onChangeValue($event)"
      label="Velocidad maxima" />
  </div>

  <div class="col-md-6">
    <app-field-select
      [value]="currentUnitKey || unitDefault"
      (valueChange)="onChangeUnit($event)"

      label="Unidad de velocidad"
      optionConfigKey="speed-unit"

    />
  </div>
</div>
